import React from "react";
import { Link } from "react-router-dom";

const HypenaFooter = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const base = process.env.PUBLIC_URL || "";

  return (
    <footer className="hn-footer">
      <div className="hn-footer-inner">
        <p className="hn-footer-copy">
          © {new Date().getFullYear()} HypeNa · <Link to="/terms" onClick={scrollTop}>Terms</Link> ·  <Link to="/privacy-policy" onClick={scrollTop}>Privacy Policy</Link> · Created by{" "}
          <a href="https://logicpp.com.na" target="_blank" rel="noreferrer">
            Logic Plus Information Technologies CC
          </a>
        </p>
        <Link to={`${base}/`} className="hn-footer-logo" onClick={scrollTop}>
          HypeNa
        </Link>
        <ul className="hn-footer-social">
          <li>
            <a href="#facebook" aria-label="Facebook">
              <i className="bi bi-facebook" />
            </a>
          </li>
          <li>
            <a href="#instagram" aria-label="Instagram">
              <i className="bi bi-instagram" />
            </a>
          </li>
          <li>
            <a href="#linkedin" aria-label="LinkedIn">
              <i className="bi bi-linkedin" />
            </a>
          </li>
          <li>
            <a href="#twitter" aria-label="Twitter">
              <i className="bi bi-twitter" />
            </a>
          </li>
          <li>
            <a href="#whatsapp" aria-label="WhatsApp">
              <i className="bi bi-whatsapp" />
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default HypenaFooter;
